module.exports = __webpack_public_path__ + "img/icon-2-bg.d1f5a580.png";